import request from '@/utils/request'

/**
 * 微信模板消息管理 API
 */
export default {
  /**
   * 分页查询
   */
  pageQuery() {
    return request({
      url: '/education/wechat-template/page',
      method: 'post',
      data: {}
    })
  },

  /**
   * 新增
   */
  insert(data) {
    return request({
      url: '/education/wechat-template/insert',
      method: 'post',
      data
    })
  },

  /**
   * 修改
   */
  update(data) {
    return request({
      url: '/education/wechat-template/update',
      method: 'post',
      data
    })
  },

  /**
   * 详情
   */
  getById(id) {
    return request({
      url: '/education/wechat-template/' + id,
      method: 'get'
    })
  },

  /**
   * 删除
   */
  remove(ids) {
    return request({
      url: '/education/wechat-template/' + ids,
      method: 'delete'
    })
  },

  /**
   * 启用/停用
   */
  toggleStatus(id, status) {
    return request({
      url: '/education/wechat-template/' + id + '/status',
      method: 'put',
      params: { status }
    })
  },

  /**
   * 从微信同步
   */
  sync() {
    return request({
      url: '/education/wechat-template/sync',
      method: 'post'
    })
  },

  /**
   * 获取场景可用变量
   */
  sceneVariables(sceneCode) {
    return request({
      url: '/education/wechat-template/scene-variables',
      method: 'get',
      params: { sceneCode }
    })
  }
}
